import { CheckCircle, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import BgImage from "../../../assets/BGimg.png";
import axiosInstance from "../../../services/axiosInterceptors";
import { palette, theme as colorTheme } from "../../../Convoze.theme";



const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;


const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [errorMess, setErrorMess] = useState("");
  const navigate = useNavigate();

  const addLoginDetails = async (data) => {
    // const encodedEmail = btoa(data?.email); 
    // localStorage.setItem("user_email", encodedEmail);
    try {
      const res = await axiosInstance.post(apiEndPointsConfig.addLogin, data);
      if (res?.data?.status?.code == 200) {
        localStorage.setItem("token", res?.data?.data?.token);
        navigate("/");
      }
    } catch (error) {
      if (error?.response?.status == 400) {
        setErrorMess(error?.response?.status);
      }
      return error;
    }
  };
  // Formik setup
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .trim("Email cannot include leading or trailing spaces")
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),
    onSubmit: (values) => {
      addLoginDetails(values);
    },
  });

  return (
    <Box>
      <Grid container>
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            display: {
              xs: "none",
              md: "flex",
            },
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            bgcolor: "#fcfafa",
            // background:
            // "radial-gradient(50% 50% at 50% 50%, #122647 0%, #090E23 100%)",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "#1c252e",
                fontWeight: 400,
                mb: 0.6,
                fontFamily: "sans-serif",
              }}
            >
              Welcome to{" "}
              <span style={{ color: positive, fontWeight: 550 }}>
                Speech Analytics
              </span>
            </Typography>
            <Typography
              sx={{
                mb: 4,
                color: "#1c252e",
              }}
            >
              Speech Analytics converts audio to insights, improving customer
              interactions.
            </Typography>
            <img
              style={{
                height: 430,
              }}
              src={
                "https://assets.minimals.cc/public/assets/illustrations/illustration-dashboard.webp"
              }
            />
          </Box>
        </Grid>
        <Grid
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          item
          md={6}
          xs={12}
        >
          <Box
            sx={{
              width: 450,
              p: 3,
            }}
          >
            <Typography
              variant="h6"
              // component="h1"
              sx={{
                // fontSize: "2.2rem",
                fontWeight: 550,
                mb: 1,
              }}
            >
              Sign in to your account
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Don’t have an account?
              <Link
                to="/sign-up"
                style={{
                  color: positive,
                  textDecoration: "none",

                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                &nbsp;Get started
              </Link>
            </Typography>

            <form onSubmit={formik.handleSubmit}>
              <Box sx={{ mb: 3 }}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  placeholder="Email address"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Box>

              <Box sx={{ mb: 1 }}>
                <TextField
                  fullWidth
                  id="password"
                  name="password"
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Box>

              <Button
                fullWidth
                type="submit"
                variant="contained"
                sx={{
                  bgcolor: "#1c252e",
                  color: "white",
                  textTransform: "none",
                  fontSize: "1rem",
                  mb: 3,
                  borderRadius: "12px",
                  "&:hover": {
                    bgcolor: primary,
                  },
                  mt: 2,
                }}
              >
                Sign in
              </Button>
              {errorMess == 400 && (
                <>
                  <Box
                    sx={{
                      bgcolor: negative,
                      borderRadius: 1,
                      p: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <CheckCircle
                      sx={{
                        color: negative,
                      }}
                    />
                    <Typography
                      sx={{
                        color: "white",
                      }}
                    >
                      Invalid email or password
                    </Typography>
                  </Box>{" "}
                </>
              )}
            </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Login;
